import axios from '../axios';
import { useQuery } from 'react-query';
import moment from 'moment';

export function useInvoiceData({
  chargers = [],
  startDate = '',
  endDate = '',
}) {
  return useQuery(
    ['host/getInvoiceList', chargers, startDate, endDate],
    ({ queryKey }) => {
      const [, chargers, startDate, endDate] = queryKey;
      const params = {
        chargers,
        startDate: moment(startDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
        endDate: moment(endDate, 'DD/MM/YYYY').format('DD-MM-YYYY'),
      };
      return axios
        .get('/host/getInvoiceList', {
          params,
        })
        .then((res) => {
          const chargers = [];
          Object.keys(res?.data).forEach((c) =>
            chargers.push({ CPID: c, ...res?.data[c] }),
          );
          return chargers;
        });
    },
    {
      enabled: !!(startDate && endDate),
    },
  );
}
